import React from 'react'
import { Link } from 'gatsby'

import { rhythm, scale } from 'src/utils/typography'

class Layout extends React.Component {
  render() {
    const { location, title, children } = this.props
    const rootPath = `${__PATH_PREFIX__}/`
    let header

    if (location.pathname === rootPath) {
      header = (
        <h1
          style={{
            ...scale(1.5),
            color: "white",
            marginBottom: rhythm(1.5),
            marginTop: 0,
          }}
        >
          <Link
            style={{
              boxShadow: `none`,
              textDecoration: `none`,
              color: `inherit`,
            }}
            to={`/`}
          >
            {title}
          </Link>
        </h1>
      )
    } else {
      header = (
        <h3
          style={{
            color: "white",
            marginTop: 0,
          }}
        >
          <Link
            style={{
              boxShadow: `none`,
              textDecoration: `none`,
              color: `inherit`,
            }}
            to={`/`}
          >
            {title}
          </Link>
        </h3>
      )
    }
    return (
      <div
        className="contentColumn"
        style={{
          marginLeft: `auto`,
          marginRight: `auto`,
          maxWidth: rhythm(44),
          padding: `${rhythm(1.5)} ${rhythm(3 / 4)}`,
        }}
      >
        {header}
        {children}
        <footer className="placeholderFooter">
          © Yoshi Walsh {new Date().getFullYear()} - 
          I acknowledge the Gadigal people of the Eora Nation, the Traditional Custodians of the land I live upon. I pay my respects to Elders past, present, and emerging.
        </footer>
        <footer className="stickyFooter">
          © Yoshi Walsh {new Date().getFullYear()} - 
          I acknowledge the Gadigal people of the Eora Nation, the Traditional Custodians of the land I live upon. I pay my respects to Elders past, present, and emerging.
        </footer>
      </div>
    )
  }
}

export default Layout
